<template>
  <div id="app" class="fh bg" ref="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
    </div> -->
  
    <!-- <div class="freccia sx" v-on:click.stop="freccia(-1)">&lt;</div>
    <div class="freccia dx" v-on:click.stop="freccia(+1)">&gt;</div> -->
    <link rel="stylesheet" href="bcat/style.css">


    <div style="display: flex;height: 100%;align-items: stretch;"  v-on:click="gotoabout">
      <div class="leftsideapp">
        <left-side></left-side>
      </div>
      <div class="rightsideapp">
        <router-view/>
      </div>
    </div>

  
    

    <bfa-footer></bfa-footer>

  </div>
</template>


<script>
// @ is an alias to /src
import BfaFooter from "@/components/BfaFooter.vue";
import LeftSide from "@/components/LeftSide.vue";
import $ from "jquery";
require("imports-loader?$=jquery,jQuery=jquery!./vendor/jquery.bcat.bgswitcher.min.js");

export default {
  name: "app",
  components: {
    BfaFooter,
    LeftSide
  },
  data() {
    return {
      imgIdx: 1,
      pos: 1
    };
  },
  mounted() {
    this.getImg(1);

    // setInterval(this.ciclaImmagine,2000);
  },
  methods: {
    formattaNomeImmagine(idx) {
      return ("0" + idx).slice(-2) + ".jpg";
    },
    // ciclaImmagine() {
    //   if (this.imgIdx>0) {
    //     var el = document.getElementsByClassName("bg")[0];
    //     el.style.backgroundImage = 'url(/img/' + this.formattaNomeImmagine(this.pos) + ')';
    //     this.pos=(this.pos+1) % this.imgIdx;
    //     if (this.pos==0) {
    //       this.pos=1;
    //     }
    //     console.log(this.pos)
    //   }
    // },
    getImg(idx) {
      var that = this;
      var img = new Image();
      img.onload = function() {
        // console.log("ok:" + idx);
        that.imgIdx++;
        that.getImg(that.imgIdx);
      };
      img.onerror = function() {
        // console.log("err:" + idx);
        // qeusta immagine non c'e' quindi ...

        window.imgArr = [];
        for (var i = 1; i < that.imgIdx; i++) {
          var singola = {
            src: "img/" + that.formattaNomeImmagine(i),
            alt: "Image " + i,
            html:
              "<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p>"
          };

          window.imgArr.push(singola);
        }

        // console.log(window.imgArr);
        $(document).ready(function() {
          $("#app").bcatBGSwitcher({
            urls: window.imgArr,
            links: true,
            timeout: 8000,
            prevnext: true
            // onGenerateEachImage: function ($html, data) {
            //   var $content = $('<div />');
            //   $content.addClass("extra-content");
            //   $content.append(data.html);
            //   return $html.append($content);
            // }
          });
        });
        // console.log("...");
      };
      img.src = "img/" + this.formattaNomeImmagine(idx);
    },
    gotoabout() {
      if (this.$router.history.current.name == "home") {
        console.log(`:: ${this.$router.history.current.name}`);
        this.$router.push({ name: "about", params: { lang: "it" } });
      }
    }
  }
};
</script>

<style>
body {
  font-family: "Montserrat";
}

.bg {
  /* The image used */
  /* background-image: url("https://www.w3schools.com/howto/img_parallax.jpg"); */
  /* background-image: url("/img/01.jpg"); */

  /* transition: background-image 2s ease-in-out; */

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.leftsideapp {
  flex: 0;
}

.rightsideapp {
  flex: 1;
}

@media screen and (min-width: 480px) {
  .leftsideapp {
    margin-left: 15%;
  }

  .rightsideapp {
    flex: 0.9;
  }
}

@media screen and (min-width: 992px) {
  .rightsideapp {
    flex: 0.75;
  }
}

.app-html {
  display: block;
  position: absolute;
  top: 0px;
  z-index: -1;
  width: 100%;
  overflow: hidden;
  height: 100%;
}

.app-html > img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  height: 100%;
}

.bodyabout #app-navigation,
.bodyabout #app-prevnext-wrapper {
  display: none !important;
}

</style>
